<template>
  <b-modal
    id="editDevice"
    ref="editDevice"
    :title="'edit_device' | i18n"
    :ok-title="'edit' | i18n"
    :cancel-title="'abort' | i18n"
    ok-variant="primary"
    cancel-variant="outline-primary"
    button-size="sm"
    @ok="updateDevice"
  >
    <text-input
      v-model="device.deviceNumber"
      :placeholder="'number_short' | i18n"
      form-group-id="number_short"
      :required="true"
    />
    <text-input
      v-model="device.deviceId"
      placeholder="App-Id"
      form-group-id="App-Id"
      :required="true"
    />
    <text-input
      v-model="device.belongsToEmployee"
      :placeholder="'employee' | i18n"
      form-group-id="employee"
      :required="true"
    />
    <text-input
      v-model="device.notes"
      :placeholder="'device_notes' | i18n"
      form-group-id="device_notes"
      :required="true"
    />
  </b-modal>
</template>

<script>
import { DeviceMixin, NotificationMixin } from '../../../../mixins';
import TextInput from '../../../inputs/text';

export default {
  name: 'EditDevice',
  components: { TextInput },
  mixins: [DeviceMixin, NotificationMixin],
  props: {
    device: {
      type: Object,
      default: () => {},
    },
    update: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async updateDevice() {
      const {
        id,
        deviceId,
        deviceNumber,
        belongsToEmployee,
        notes,
      } = this.device;

      const data = {
        id,
        deviceId,
        deviceNumber,
        belongsToEmployee,
        notes,
      };

      try {
        await this.deviceService.editDevice(data);
        await this.update();
        this.showNotification({
          type: 'success',
          title: this.$translate('edit_device'),
          message: this.$translate('success'),
        });
      } catch (err) {
        this.showNotification({
          type: 'error',
          title: this.$translate('edit_device'),
          message: err.message,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.owner-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.owner-block {
  height: 60px;
  display: flex;
  justify-content: center;
  border-radius: 0.2rem;
  box-shadow: 0px 0px 17px -7px rgba(0, 0, 0, 0.35);
  width: fit-content;
  padding: 10px;
  margin: 10px;
  flex-direction: column;
}
</style>
